<script setup lang="ts">
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "./repeat/Navbar.vue";
const router = useRouter();
const hemail = "muc4616@gmail.com";
</script>
<template>
  <div class="privacy">
    <div class="kong">
      <Header> </Header>
    </div>
    <div class="wrap">
      <div class="title">
        <div class="title_li">
          <div class="title_lis">
            <a class="no" href="/">{{ $t("system.contact.register.s_y") }}</a>
            <text>></text>
            <a class="th">{{ $t("system.home.footer.f_text_t") }}</a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content_box">
          <div class="box_head">
            <h4 class="head_text">{{ $t("system.privacy.head_text") }}</h4>
          </div>
          <!-- 内容 -->
          <div class="box_inner">
            <p style="line-height: 3em">
              <strong>{{ $t("system.privacy.s_1") }}</strong>
              <br />
              {{ $t("system.privacy.b_1") }}
              <br />
              <br />
              <strong>{{ $t("system.privacy.s_2") }}</strong>
              <br />
              {{ $t("system.privacy.b_2") }}
              <br />
              <br />
              <strong>{{ $t("system.privacy.s_3") }}</strong>
              <br />       
              {{ $t("system.privacy.b_3") }}
              <br />
              {{ $t("system.privacy.b_4") }}
              <br />
              {{ $t("system.privacy.b_5") }}
              <br />
              {{ $t("system.privacy.b_6") }}
              <br />
              {{ $t("system.privacy.b_7") }}
              <br />
              {{ $t("system.privacy.b_8") }}
              <br />
              {{ $t("system.privacy.b_9") }}
              <br />
              {{ $t("system.privacy.b_10") }}
              <br />
              {{ $t("system.privacy.b_11") }}
              <br />
              {{ $t("system.privacy.b_12", { hemail }) }}
              <br />
              <br />
              <strong>{{ $t("system.privacy.s_4") }}</strong>
              <br />
              {{ $t("system.privacy.b_13") }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.wrap {
  width: 100%;
  background-color: #fff;
}
.title {
  width: 100%;
  height: auto;
  line-height: 26px;
  padding: 30px 0;
}
.title_li {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}
.title_lis {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -10px;
  font-weight: bold;
}
.no {
  height: 26px;
  text-decoration: none;
  outline: none;
  color: #3e3a39;
  padding: 0 8px 0 0;
}
.th {
  height: 26px;
  text-decoration: none;
  outline: none;
  color: #3e3a39;
  padding: 0 0 0 8px;
}
.content {
  padding: 40px 0 70px;
}
.content_box {
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.box_head {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 30px;
}
.head_text {
  font-size: 24px;
  font-weight: bold;
}
h4 {
  margin: 0;
}
.box_inner {
  font-size: 16px;
}
p {
  margin: 0;
}
</style>
